document.addEventListener('DOMContentLoaded', function() {
  class AboutTabs {
    constructor(container) {
      this.container = container || document;
      this.tablist = this.container.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.container.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.container.querySelectorAll('[role="tabpanel"]'));
      this.tabContainer = this.tablist.closest('.AboutUsPage-TabSwitcher');
      this.tabList = this.tablist;
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      
      if (this.tabs.length === 0 || this.panels.length === 0) return;
      
      this.init();
    }
    
    init() {
      // Set initial states
      this.tabs.forEach(tab => {
        const panelId = tab.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        
        if (!panel) return;
        
        // Set initial tabindex
        if (tab.getAttribute('aria-selected') === 'true') {
          tab.setAttribute('tabindex', '0');
          panel.classList.add('AboutUsPage-TabContent_isActive');
        } else {
          tab.setAttribute('tabindex', '-1');
          panel.classList.remove('AboutUsPage-TabContent_isActive');
        }
        
        // Add event listeners
        tab.addEventListener('click', (e) => this.handleTabClick(e));
        tab.addEventListener('keydown', (e) => this.handleKeyDown(e));
      });
      
      // Add touch events for horizontal swiping
      this.addSwipeHandlers();
      
      // Show swipe info on mobile if needed
      this.checkSwipeInfo();
      window.addEventListener('resize', () => this.checkSwipeInfo());
    }
    
    addSwipeHandlers() {
      if (!this.tabContainer) return;
      
      // Mouse events for desktop
      this.tabContainer.addEventListener('mousedown', (e) => {
        this.isDragging = true;
        this.startX = e.pageX - this.tabContainer.offsetLeft;
        this.scrollLeft = this.tabContainer.scrollLeft;
        this.tabContainer.style.cursor = 'grabbing';
        this.tabContainer.style.userSelect = 'none';
      });
      
      this.tabContainer.addEventListener('mouseleave', () => {
        this.isDragging = false;
        this.tabContainer.style.cursor = 'grab';
      });
      
      this.tabContainer.addEventListener('mouseup', () => {
        this.isDragging = false;
        this.tabContainer.style.cursor = 'grab';
      });
      
      this.tabContainer.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.pageX - this.tabContainer.offsetLeft;
        const walk = (x - this.startX) * 1.5; // Scroll faster than the mouse moves
        this.tabContainer.scrollLeft = this.scrollLeft - walk;
      });
      
      // Touch events for mobile
      this.tabContainer.addEventListener('touchstart', (e) => {
        this.isDragging = true;
        this.startX = e.touches[0].pageX - this.tabContainer.offsetLeft;
        this.scrollLeft = this.tabContainer.scrollLeft;
      }, { passive: true });
      
      this.tabContainer.addEventListener('touchend', () => {
        this.isDragging = false;
      }, { passive: true });
      
      this.tabContainer.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.touches[0].pageX - this.tabContainer.offsetLeft;
        const walk = (x - this.startX) * 1.5; // Scroll faster than the finger moves
        this.tabContainer.scrollLeft = this.scrollLeft - walk;
      }, { passive: false });
    }
    
    handleTabClick(event) {
      const tab = event.currentTarget;
      this.activateTab(tab);
    }
    
    handleKeyDown(event) {
      const tab = event.currentTarget;
      let index = this.tabs.indexOf(tab);
      
      switch(event.key) {
        case 'ArrowRight':
          event.preventDefault();
          index = (index + 1) % this.tabs.length;
          this.activateTab(this.tabs[index]);
          break;
          
        case 'ArrowLeft':
          event.preventDefault();
          index = (index - 1 + this.tabs.length) % this.tabs.length;
          this.activateTab(this.tabs[index]);
          break;
          
        case 'Home':
          event.preventDefault();
          this.activateTab(this.tabs[0]);
          break;
          
        case 'End':
          event.preventDefault();
          this.activateTab(this.tabs[this.tabs.length - 1]);
          break;
          
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.activateTab(tab);
          break;
      }
    }
    
    activateTab(tab) {
      const panelId = tab.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      
      if (!panel) return;
      
      // Deactivate all tabs and panels
      this.tabs.forEach(t => {
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
        t.classList.remove('AboutUsPage-TabSwitcherButton_active');
      });
      
      this.panels.forEach(p => {
        p.classList.remove('AboutUsPage-TabContent_isActive');
      });
      
      // Activate the selected tab and panel
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      tab.classList.add('AboutUsPage-TabSwitcherButton_active');
      panel.classList.add('AboutUsPage-TabContent_isActive');
      
      // Focus the tab
      tab.focus();
      
      // Scroll the tab into view if needed (for mobile)
      if (window.innerWidth <= 1024) {
        tab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
    
    checkSwipeInfo() {
      const swipeInfo = document.querySelector('.AboutUsPage-SwipeInfo');
      if (!swipeInfo) return;
      
      // Show swipe info on mobile if tabs are scrollable
      const tabsContainer = this.tablist.parentElement;
      const isScrollable = tabsContainer.scrollWidth > tabsContainer.clientWidth;
      
      if (isScrollable && window.innerWidth <= 1024) {
        swipeInfo.style.display = 'flex';
      } else {
        swipeInfo.style.display = 'none';
      }
    }
  }
  
  // Initialize the tabs
  const aboutTabs = new AboutTabs(document.querySelector('.AboutUsPage'));
});
